module.exports = function (Component) {
  Component.options.__i18n = Component.options.__i18n || []
  Component.options.__i18n.push('{"en":{"systemList":"Alert Notification"},"zh":{"systemList":"告警消息推送"}}')
  delete Component.options._Ctor
}
